'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function LAFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("mask", { id: "mantine-02nghgem2", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-02nghgem2)" }, /* @__PURE__ */ React.createElement("path", { fill: "#e31d1c", d: "M0 16h32v6a2 2 0 01-2 2H2a2 2 0 01-2-2z" }), /* @__PURE__ */ React.createElement("path", { fill: "#2e42a5", d: "M0 8h32v8H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#e31d1c", d: "M2 0h28a2 2 0 012 2v6H0V2a2 2 0 012-2z" }), /* @__PURE__ */ React.createElement("circle", { cx: "16", cy: "11.99", r: "3.75", fill: "#f7fcff" })))
  );
}

export { LAFlag };
//# sourceMappingURL=LA.mjs.map
